import React, { useEffect } from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';

// 参考
// ryoblg.com/blog/post/gatsby-syntax-highlight/

type Props = {
  langname: string;
  children: JSX.Element;
};

const PrismComponent = (props: Props): JSX.Element => {
  const { langname, children } = props;

  useEffect(() => {
    Prism.highlightAll();
  });

  return (
    <pre>
      <code className={`language-${langname}`}>{children}</code>
    </pre>
  );
};

export { PrismComponent };
